import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const subs = new Set();
let ultimo = [];
export const recargarPlanes = async () => {
  ultimo = (await api.get("/ocio/planes")).data;
  subs.forEach((f) => f(ultimo));
  return ultimo;
};

export const esPasado = (p, ahora = new Date()) => new Date(`${p.fecha}T${p.hora || "23:59"}`) < ahora;

export const usePlanes = () => {
  const [planes, setPlanes] = useState(ultimo);
  useEffect(() => {
    subs.add(setPlanes);
    recargarPlanes().catch(() => {});
    return () => subs.delete(setPlanes);
  }, []);
  return { planes, proximos: planes.filter((p) => !esPasado(p)), historial: planes.filter((p) => esPasado(p)).reverse() };
};

export const TIPOS_OCIO = [["cine", "Cine"], ["teatro", "Teatro"], ["concierto", "Concierto"], ["restaurante", "Restaurante"], ["hotel", "Hotel"],
  ["viaje", "Viaje"], ["museo", "Museo"], ["espectaculo", "Espectáculo"], ["otro", "Otra actividad"]];
export const tipoOcio = (t) => (TIPOS_OCIO.find(([k]) => k === t) || TIPOS_OCIO[8])[1];
const hoyISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };
export const esHoy = (p) => p.fecha === hoyISO();
// Enlace estándar de Google Maps a partir del lugar guardado (sin API ni claves). null si no hay datos suficientes.
export const enlaceMapa = (p) => {
  const lugar = (p.lugar || "").trim();
  if (lugar.length < 4 || !(/\d/.test(lugar) || /[\s,]/.test(lugar))) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(lugar)}`;
};
export const fechaPlan = (p) => {
  const d = new Date(`${p.fecha}T12:00`);
  const conAnio = d.getFullYear() !== new Date().getFullYear();
  return d.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long", ...(conAnio ? { year: "numeric" } : {}) }) + (p.hora ? ` · ${p.hora}` : "");
};

// Viajes confirmados por el usuario (viaje_id) que tienen algún plan hoy.
export const viajesDeHoy = (planes) => {
  const g = {};
  planes.forEach((p) => { if (p.viaje_id) (g[p.viaje_id] = g[p.viaje_id] || []).push(p); });
  return Object.values(g).filter((ps) => ps.length > 1 && ps.some(esHoy)).map((ps) => ps.filter(esHoy)).filter((ps) => ps.length > 1);
};

const normTxt = (t) => String(t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const destino = (p) => normTxt((String(p.nombre).split("→")[1] || "").replace(/\(.*?\)/g, "")).trim();

// Sugerencia prudente (nunca se une sin confirmar): trayecto + otro plan del mismo día cuyo nombre o lugar contiene la ciudad de destino.
export const sugerenciaViaje = (proximos) => {
  for (const a of proximos.filter((p) => p.tipo === "viaje" && destino(p).length >= 3)) {
    const b = proximos.find((x) => x.id !== a.id && x.tipo !== "viaje" && x.fecha === a.fecha && !(a.viaje_id && a.viaje_id === x.viaje_id)
      && !(a.no_viaje_con || []).includes(x.id) && !(x.no_viaje_con || []).includes(a.id)
      && new RegExp(`\\b${destino(a).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`).test(normTxt(`${x.nombre} ${x.lugar}`)));
    if (b) return { a, b, ciudad: String(a.nombre).split("→")[1].replace(/\(.*?\)/g, "").trim() };
  }
  return null;
};
